module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['card', _vm.cardVariant, _vm.cardAlign, _vm.cardInverse]
  }, [_vm._t("img", [(_vm.img) ? _c('img', {
    staticClass: "card-img",
    attrs: {
      "src": _vm.img,
      "alt": _vm.imgAlt
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.header || _vm.showHeader) ? _c(_vm.headerTag, {
    tag: "component",
    staticClass: "card-header"
  }, [_vm._t("header", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.header)
    }
  })])], 2) : _vm._e(), _vm._v(" "), (_vm.noBlock) ? [_vm._t("default")] : _c('div', {
    class: _vm.blockClass
  }, [(_vm.title) ? _c('h4', {
    staticClass: "card-title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.subTitle) ? _c('h6', {
    staticClass: "card-subtitle mb-2 text-muted",
    domProps: {
      "innerHTML": _vm._s(_vm.subTitle)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (_vm.footer || _vm.showFooter) ? _c(_vm.footerTag, {
    tag: "component",
    staticClass: "card-footer"
  }, [_vm._t("footer", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.footer)
    }
  })])], 2) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-394bceef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/card.vue
// module id = 235
// module chunks = 0